import Vue from 'vue'
import configureObj from './configure.js';

// 格式化时间到秒
window.timestampToTime = Vue.prototype.timestampToTime = function (time, type) {
  var date = new Date(time);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
  var Y = date.getFullYear() + '-';
  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
  var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());

  switch (type) {
    case 0:
      return Y + M + D + h + m + ':' + s;
    case 1:
      return Y + M + D;
  }
}

// loading清除
window.clearLoading = Vue.prototype.clearLoading = async function (event) {
  setTimeout(() => {
    event.loading = false
  }, 500);
}

// 列表分页后返回顶部
window.handleRefTable = Vue.prototype.handleRefTable = function (refTable) {
  refTable.bodyWrapper.scrollTop = 0;
}

//去空格处理
window.removeSpace = Vue.prototype.removeSpace = function (type, value) {
  let val = value || "", str = "";
  switch (type) {
    case 1:
      str = val.replace(/(^\s+)|(\s+$)/g, "");
      break;
    case 2:
      str = val.replace(/\s+/g, "");
      break;
  }

  return str;
}

//去除标签样式
window.removeText = Vue.prototype.removeText = function (html) {
  let val = html || "", newHtml = "";

  let relStyle = /style\s*?=\s*?([‘"])[\s\S]*?\1/g; //去除样式

  let relTag = /<.+?>/g; //去除标签

  let relClass = /class\s*?=\s*?([‘"])[\s\S]*?\1/g; // 清除类名 let newHtml = "";
  if (val) {

    newHtml = val.replace(relStyle, "");

    newHtml = newHtml.replace(relTag, '');

    newHtml = newHtml.replace(relClass, '');

  }

  return newHtml;
}


// 正则验证
window.verifyRegular = Vue.prototype.verifyRegular = function (type, value, callback) {
  // 清空空格
  let regStr = /(^\s+)|(\s+$)/g;
  switch (type) {
    case "phone": // 电话号码/手机号码/400/800
      value = regStr.test(value) ? value : removeSpace(2, value);
      let phoneArr = /(^0[0-9]{2,3}[0-9]{8})|(^(0[0-9]{2,3}\-)?([2-9][0-9]{6,7})+(\-[0-9]{1,4})?$)|(^((\(\d{3}\))|(\d{3}\-))?(1[3456789]\d{9})$)|(^(400)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(400)-(\d{3})-(\d{4}$))|(^(400)(\d{3})(\d{4}$))|(^(400)-(\d{4})-(\d{3}$))|(^(800)-(\d{3})-(\d{4})(.)(\d{1,4})$)|(^(800)-(\d{3})-(\d{4}$))|(^(800)(\d{3})(\d{4}$))|(^(800)-(\d{4})-(\d{3}$))/;
      if (!phoneArr.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "mobile": // 手机号码
      value = regStr.test(value) ? value : removeSpace(2, value);
      let phoneReg = /^1(3|4|5|6|7|8|9)\d{9}$/;
      if (!phoneReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "taskName": // 任务名称
      value = regStr.test(value) ? value : removeSpace(2, value);
      let taskNameReg = /^[\u4e00-\u9fa5_a-zA-Z0-9~!@#$^&*,.?:;""''{}()·\-+=，。<>《》/？！@#￥%……：；、“”’‘（）【】]+$/;
      if (!taskNameReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "name": // 名字
      value = regStr.test(value) ? value : removeSpace(1, value);
      if (value.length < 2) {
        callback(new Error("姓名请输入 2-20 位字符"));
        return;
      }
      let nameReg = /^[\u4e00-\u9fa5·\-]{0,}$/;
      if (!nameReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "email": // 邮箱
      value = regStr.test(value) ? value : removeSpace(1, value);
      let emailReg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "code": // 身份证号
      value = regStr.test(value) ? value : removeSpace(2, value);
      let codeReg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
      if (!codeReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "bankName": // 开户行
      value = regStr.test(value) ? value : removeSpace(2, value);
      let bankNameReg = /^[\u4e00-\u9fa5_a-zA-Z~!@#$^&*,.?:;""''{}()·\-，。？：；、“”‘’（）【】]+$/;
      if (!bankNameReg.test(value)) {
        callback(new Error("收款方账户只能输入中文"));
      } else {
        callback();
      }
      break;
    case "bank": // 开户行
      value = regStr.test(value) ? value : removeSpace(2, value);
      let bankReg = /^[\u4e00-\u9fa5_a-zA-Z~!@#$^&*,.?:;""''{}()·\-，。？：；、“”‘’（）【】]+$/;
      if (!bankReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "bankAccount": // 银行账户
      value = regStr.test(value) ? value : removeSpace(2, value);
      let bankAccountReg = /^[0-9\-]{1,35}$/;
      if (!bankAccountReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "address": // 地址、城市、开户行
      value = regStr.test(value) ? value : removeSpace(2, value);
      let addressReg = /^[\u4e00-\u9fa5_a-zA-Z0-9~!@#$^&*,.?:;""''{}()·\-，。？：；、“”’‘（）【】]+$/;
      if (!addressReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
    case "merchant": // 商户名称
      value = regStr.test(value) ? value : removeSpace(2, value);
      let merchantReg = /^[\u4e00-\u9fa5_a-zA-Z0-9\-+()【】·（）\[]+$/;
      if (!merchantReg.test(value)) {
        callback(new Error());
      } else {
        callback();
      }
      break;
  }
  return
}

// 将数字金额转换为大写金额
window.smallToBig = Vue.prototype.smallToBig = function (money) {
  var cnNums = new Array(
    "零",
    "壹",
    "贰",
    "叁",
    "肆",
    "伍",
    "陆",
    "柒",
    "捌",
    "玖"
  ); //汉字的数字
  var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
  var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
  var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
  var cnInteger = "整"; //整数金额时后面跟的字符
  var cnIntLast = "元"; //整数完以后的单位
  //最大处理的数字
  var maxNum = 999999999999999.9999;
  var integerNum; //金额整数部分
  var decimalNum; //金额小数部分
  //输出的中文金额字符串
  var chineseStr = "";
  var parts; //分离金额后用的数组，预定义
  if (money == "") {
    return "";
  }

  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return "超出最大处理数字";
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }

  // 四舍五入保留两位小数,转换为字符串
  // money = Math.round(money * 100).toString();
  // 保留两位小数,超过部分直接舍掉,转换为字符串
  money = Math.floor(money * 100).toString();
  integerNum = money.substr(0, money.length - 2);
  decimalNum = money.substr(money.length - 2);

  // 获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    var zeroCount = 0;
    var IntLen = integerNum.length;
    for (var i = 0; i < IntLen; i++) {
      var n = integerNum.substr(i, 1);
      var p = IntLen - i - 1;
      var q = p / 4;
      var m = p % 4;
      if (n == "0") {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != "") {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != "0") {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == "") {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == "" || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

// 金额转换,逗号分隔，保留2位小数(不四舍五入)
window.moneyConvert = Vue.prototype.moneyConvert = function (value) {
  if (value === 0) {
    return '0.00'
  }
  if (!value || value === "" || value === null || value === undefined) {
    return '0.00'
  }

  var value = Math.floor(value * 100) / 100;
  var xsd = value.toString().split(".");
  if (xsd.length == 1) {
    value = value.toString() + ".00";
    return value;
  }

  if (xsd.length > 1) {
    if (xsd[1].length < 2) {
      value = value.toString() + "0";
    }
    return value;
  }
}
// 金额转换,逗号分隔，保留2位小数(四舍五入)
window.sumConvert = Vue.prototype.sumConvert = function (val, fix = 2) {
  var str = "";
  if (val == 0) {
    return "0.00";
  }
  if (!val) {
    return "0.00";
  }

  if (val < 0) {
    str = val.toString().substr(0, 1);
    val = val.toString().substr(1, val.toString().length - 1);
  }
  val = parseFloat(val).toFixed(fix); // 保留小数2位
  val = "" + val; // 转换成字符串
  let int = val.slice(0, fix * -1 - 1); // 拿到整数
  let ext = val.slice(fix * -1 - 1); // 获取到小数
  //每个三位价格逗号
  int = int.split("").reverse().join(""); // 翻转整数
  let temp = ""; // 临时变量
  for (let i = 0; i < int.length; i++) {
    temp += int[i];
    if ((i + 1) % 3 == 0 && i != int.length - 1) {
      temp += ","; // 每隔三个数字拼接一个逗号
    }
  }
  temp = temp.split("").reverse().join(""); // 加完逗号之后翻转
  temp = temp + ext; // 整数小数拼接
  return str + temp; // 返回
}

// input只能输入数字和两位小数点校验
window.inputVerify = Vue.prototype.inputVerify = function (event) {
  event = event.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')
  return event
}

//导出下载
window.downloadFileFun = Vue.prototype.downloadFileFun = function (url, name) {
  let hrefUrl = window.URL.createObjectURL(url);
  const link = document.createElement('a'); // 生成一个a标签。
  link.href = hrefUrl; // href属性指定下载链接
  link.download = name + ".xls"; // dowload属性指定文件名
  link.click(); // click()事件触发下载
}

//按钮权限判断
window.getBtnStatus = Vue.prototype.getBtnStatus = function (val) {
  let sta, bts = sessionStorage.getItem("bts_M") || "noBts";
  sta = (bts.indexOf(val) != -1) ? true : false;
  return sta;
}

// 保留两位小数 不四舍五入
window.getNumberTwoDecimal = Vue.prototype.getNumberTwoDecimal = function (val) {
  // let b = ((val*100).toFixed(3) / 100).toFixed(2);
  let n = val.toString();
  let b = Number(n.substring(0, (n.indexOf('.') > -1 ? (n.indexOf('.') + 3) : n.length))).toFixed(2)
  console.log("b", b)
  return b;
}

// 设置公共变量存储配置信息
let _configureArr = configureObj.configure["B"];
window.configureInfos = Vue.prototype.configureInfos = _configureArr;

// 判断是否包含当前账户
window.accountIndexOf = Vue.prototype.accountIndexOf = function (obj, num) {
  let bln = "";
  for (var i = 0; i < obj.length; i++) {
    if (obj[i].value == num) {
      bln = obj[i].label;
    }
  }
  return bln;
}

// 表格浮动/清除浮动
window.isUserAgent = Vue.prototype.isUserAgent = function () {
  let l = true;
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    l = true;
  } else if (/(Android)/i.test(navigator.userAgent)) {
    l = true;
  } else {
    l = false;
  }
  ;
  return l;
}





// WEBPACK FOOTER //
// ./src/utils/common.js